import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/core/BasicLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/core/FullWrapper/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/core/BasicImage/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/core/ScrollAnimation/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/Achievements/Card/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/Achievements/style.module.sass");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/OfferBody/OfferForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/OfferBody/style.module.sass");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/OfferButton/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/Reasons/ReasonCard/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/Reasons/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/RunningLine/CompanyList/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/RunningLine/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/ServiceProjectCases/CasesList/CasesListItem/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/ServiceProjectCases/CasesList/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/ServiceProjectCases/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/features/Breadcrumbs/style.module.sass");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/features/service/service-development/PersonalAccounts/Title/style.module.sass");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/components/shared/sections/ServiceServices/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/184/node_modules/next/dist/client/script.js");
